var React = require('react');

function Location (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.862 8.54478C14.862 13.6378 8.31383 18.0033 8.31383 18.0033C8.31383 18.0033 1.76562 13.6378 1.76562 8.54478C1.76563 6.80809 2.45552 5.14253 3.68355 3.91451C4.91157 2.68648 6.57714 1.99658 8.31383 1.99658C10.0505 1.99658 11.7161 2.68648 12.9441 3.91451C14.1721 5.14253 14.862 6.80809 14.862 8.54478Z","stroke":"#FCEC92","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M8.31359 10.7275C9.51908 10.7275 10.4963 9.75028 10.4963 8.54479C10.4963 7.3393 9.51908 6.36206 8.31359 6.36206C7.1081 6.36206 6.13086 7.3393 6.13086 8.54479C6.13086 9.75028 7.1081 10.7275 8.31359 10.7275Z","stroke":"#FCEC92","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Location.defaultProps = {"width":"16","height":"20","viewBox":"0 0 16 20","fill":"none"};

module.exports = Location;

Location.default = Location;
